module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9a2b4738446648557be6ffc033a6985e.gif";